import React from 'react'
import { GemIcon } from '../svg'
import { PlusOutlined } from '@ant-design/icons'
import useUserWallet from '@/hooks/swr/useUserWallet'
import { formatMessageAmount } from '@/utils/subscribe'
import LifecycleLink from '@/components/common/LifecycleLink'
import useI18n from 'Hooks/useI18n'
import { withLocale } from '@/locales'
import { useRecoilState } from 'recoil'
import { GemsAndSubscriptionPageSource } from '@/store/chat'

const GemsButton = () => {
  const { t, lang } = useI18n()
  const {
    userWalletInfo: { gemAmount },
  } = useUserWallet()
  const [, setPageSource] = useRecoilState(GemsAndSubscriptionPageSource)

  return (
    <LifecycleLink
      href={withLocale('/balance', lang)}
      prefetch
      className="group pointer-events-auto flex h-9 items-center gap-1 rounded-full border border-white/40 bg-black/20 px-3 shadow-[0_2px_4px_0_rgba(0,0,0,0.06)] transition hover:border-hover-border"
      onClick={() => setPageSource('profile')}
    >
      <GemIcon size={20} />
      <p className="mr-1 text-[14px] leading-4 text-[#FF6480]">
        {formatMessageAmount(t, gemAmount)}
      </p>
      <span className="flex h-5 w-5 items-center justify-center rounded-full border border-white/20 transition-colors group-hover:border-hover-border">
        <PlusOutlined className="text-xs text-white" />
      </span>
    </LifecycleLink>
  )
}

export default GemsButton
